jQuery(document).ready(() => {
  jQuery('.itbl-hero2 [data-animation]').each(function (i, animation) {
    bodymovin.loadAnimation({
      container: $(this)[0],
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: $(this).data('animation')
    })
  })
})